// src/components/ModalAgregarArticulo.jsx
import React, { useState } from "react";
import clienteAxios from "../../axios";

const ModalAgregarArticulo = ({ show, onClose, cocinaId, onArticuloAgregado }) => {
    const [nuevoArticulo, setNuevoArticulo] = useState({ nombre_articulo: "", cantidad: "", unidad: "" });

    // Función para manejar el envío del formulario
    const handleAgregarArticulo = async (e) => {
        e.preventDefault();
        if (nuevoArticulo.nombre_articulo.trim() === "" || nuevoArticulo.cantidad.trim() === "" || nuevoArticulo.unidad.trim() === "") {
            alert("Todos los campos son requeridos.");
            return;
        }

        try {
            // Ajuste del módulo a 'inventario_cocina' y uso de 'cocinaId'
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "inventario_cocina", // Cambiado de 'inventario' a 'inventario_cocina'
                cocina_id: cocinaId, // Cambiado de 'restaurante_id' a 'cocina_id'
                nombre_articulo: nuevoArticulo.nombre_articulo,
                cantidad: nuevoArticulo.cantidad,
                unidad: nuevoArticulo.unidad
            });

            onArticuloAgregado(); // Actualiza el inventario al agregar el artículo
            onClose(); // Cierra el modal
            setNuevoArticulo({ nombre_articulo: "", cantidad: "", unidad: "" }); // Resetea el formulario
        } catch (error) {
            console.log(error);
        }
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Agregar Nuevo Artículo</h2>
                <form onSubmit={handleAgregarArticulo}>
                    <input
                        type="text"
                        value={nuevoArticulo.nombre_articulo}
                        onChange={(e) => setNuevoArticulo({ ...nuevoArticulo, nombre_articulo: e.target.value })}
                        placeholder="Nombre del artículo"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={50}
                    />
                    <input
                        type="number"
                        value={nuevoArticulo.cantidad}
                        onChange={(e) => setNuevoArticulo({ ...nuevoArticulo, cantidad: e.target.value })}
                        placeholder="Cantidad"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={10}
                    />
                    <input
                        type="text"
                        value={nuevoArticulo.unidad}
                        onChange={(e) => setNuevoArticulo({ ...nuevoArticulo, unidad: e.target.value })}
                        placeholder="Unidad (e.g. kg, litros)"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={10}
                    />
                    <div className="flex justify-end">
                        <button type="submit" className="bg-green-500 rounded text-white px-4 py-2 mr-2">
                            Agregar
                        </button>
                        <button type="button" onClick={onClose} className="bg-gray-500 rounded text-white px-4 py-2">
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarArticulo;
